// @mui
import IconButton from "@mui/material/IconButton";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Tooltip from "@mui/material/Tooltip";
import { Link } from "react-router-dom";
// components
import Iconify from "src/components/iconify";
import Restricted from "src/PermissionProvider/Restricted";
import { PrmsEnum } from "src/types/permissions";

// ----------------------------------------------------------------------

type Props = {
  row: any;
};

export default function CustomMessageTableRow({ row }: Props) {
  return (
    <>
      <TableRow hover>
        <TableCell sx={{ whiteSpace: "nowrap", textAlign: "center" }}>
          {row?.subject}
        </TableCell>
        <TableCell sx={{ whiteSpace: "nowrap", textAlign: "center" }}>
          {row?.createdAt ? new Date(row?.createdAt)?.toLocaleDateString() : ""}
        </TableCell>
        <TableCell sx={{ whiteSpace: "nowrap", textAlign: "center" }}>
          {row?.updatedAt ? new Date(row?.updatedAt)?.toLocaleDateString() : ""}
        </TableCell>

        <TableCell sx={{ whiteSpace: "nowrap", textAlign: "center" }}>
          <Tooltip title="info" placement="bottom" arrow>
            <Link to={`/dashboard/custom-message/${row.id}`}>
              <IconButton>
                <Iconify
                  icon="akar-icons:info"
                  width="27"
                  height="27"
                  color="#FFAB8B"
                />
              </IconButton>
            </Link>
          </Tooltip>
        </TableCell>
      </TableRow>
    </>
  );
}
